import React from "react";
import { Typography, Box, GridListTile, GridList } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import MediaExCard from "./MediaExCard";
import ExCard from "./ExCard";
import ListExp from "./ListExp";

export default function Experience() {
  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-around",
      overflow: "hidden",
      backgroundColor: theme.palette.background.paper,
    },
    gridList: {
      width: 500,
      height: 450,
    },
    mainCard: {
      height: 648.0,
    },
    Media: {
      padding: " 6% 0",
      height: "100%",
    },
    onlExp: {
      color: "white",
      width: "100%",
      margin: "15px 0",
      [theme.breakpoints.down("sm")]: {
        fontSize: "16px",
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: "22px",
      },
    },
    TraiNghiemButton: {
      width: 200,
      margin: "20px 0 20px 0",
      border: "1px solid #fd3a69",
      borderRadius: 10,
      textAlign: "center",
      fontSize: 18,
      padding: "7px 0 10px 0",
      color: "white",
    },
    gridList: {
      flexWrap: "nowrap",
      // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
      transform: "translateZ(0)",
    },
  }));

  const classes = useStyles();
  return (
    <div>
      <div style={{ height: "100%", position: "relative", top: "10px" }}>
        {" "}
        <Grid item container xs={12}>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              style={{ fontSize: "40px", fontWeight: "bold", color: "white" }}
            >
              Trải nghiệm trực tuyến
            </Typography>
            <Typography variant="h6" className={classes.onlExp}>
              Gặp gỡ mọi người trên khắp thế giới trong khi thử làm những điều
              mới mẻ. Tham gia các phiên video tương tác, truyền trực tiếp do
              những người tổ chức trải nghiệm có một không hai dẫn dắt – trải
              nghiệm mọi hoạt động mà không cần rời khỏi nhà.
            </Typography>
          </Grid>

          <div item className={classes.TraiNghiemButton}>
            Trải nghiệm ngay
          </div>
        </Grid>
      </div>

      <div>
        <Box display={{ xs: "none", md: "block" }} className={classes.Media}>
          <ExCard />
        </Box>
        <Box className={classes.Media} display={{ xs: "block", md: "none" }}>
          <GridList className={classes.gridList} cols={2.5}>
            {ListExp.map((tile, index) => {
              return (
                <MediaExCard
                  key={index}
                  imgURL={tile.imgURL}
                  title={tile.title}
                />
              );
            })}
          </GridList>
        </Box>
      </div>
    </div>
  );
}
